import React from 'react';

/**
 * Lightweight footer for the admin workspace — does not replace the user/sidebar footer.
 */
const AdminFooter: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="shrink-0 border-t border-border bg-background/80 px-6 py-3">
      <p className="text-center text-xs text-muted-foreground">
        Kiosk Admin © {year}
      </p>
    </footer>
  );
};

export default AdminFooter;
